import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { appPalette } from 'theme/App.palette';

const colors = appPalette.colors;
const svgString = encodeURIComponent(
  renderToStaticMarkup(
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
      <polygon
        fill={colors.acura_red}
        points='82.5,158.9 27,103.4 36.9,93.5 82.5,139.1 176.3,45.3 186.2,55.2 '
      />
    </svg>
  )
);

export const useStyles = makeStyles({
  checkbox_container: {
    width: '100%',
    minHeight: '1.75rem',
    height: 'auto',
    position: 'relative',
    display: 'flex',
    '& .acr-paragraph-8': {
      '& a': {
        borderBottom: '0.0625rem solid #cdcdcd',
        padding: '0.125rem',
        '&:hover': {
          color: 'inherit',
        },
        '&:focus': {
          color: 'inherit',
          border: 0,
          boxShadow: 'inset 0 0 0 0.125rem #1e2123',
          outline: 0,
        },
        transition: '.2s',
      },
    },
    '& input[type="checkbox"]': {
      display: 'block',
      margin: '0 1.0625rem 0 0 !important',
      '&:focus': {
        outline: `0.125rem solid ${colors.dark_grey_1}`,
        outlineOffset: '-0.0625rem',
      },
    },
  },
  checkbox: {
    boxSizing: 'border-box',
    position: 'relative',
    minWidth: '1.75rem',
    height: '1.75rem',
    appearance: 'initial',
    WebkitAppearance: 'initial',
    border: '0.0625rem solid',
    borderColor: colors.mid_grey_2,
    backgroundColor: colors.off_white,
    width: 'auto',
    '&:checked::after': {
      content: "''",
      backgroundImage: `url("data:image/svg+xml,${svgString}")`,
      height: '1.25rem',
      left: '0.25rem',
      position: 'absolute',
      top: '0.25rem',
      width: '1.25rem',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  error_text: {
    color: colors.acura_red,
    position: 'absolute',
    width: '100%',
    left: '2.8125rem',
    bottom: '-1.5625rem',
  },
});
